import * as React from 'react';
import { useSelector } from 'react-redux';
import { IAppState } from '../core/redux/IAppState';
import { ResultsPlaceholder } from '../guestSearch/ResultsPlaceholder';

export const LandingIndexRoute: React.FC = () => {
  const resources = useSelector((s: IAppState) => s.locale);
  const enableSearchHistory = useSelector((s: IAppState) => s.resortToolsConfig.enableSearchHistory);

  return (
    <ResultsPlaceholder
      resources={resources}
      enableSearchHistory={enableSearchHistory}
    />
  );
};
